import { render, staticRenderFns } from "./ClientDetailView.vue?vue&type=template&id=24250886&scoped=true&"
import script from "./ClientDetailView.vue?vue&type=script&lang=js&"
export * from "./ClientDetailView.vue?vue&type=script&lang=js&"
import style0 from "./ClientDetailView.vue?vue&type=style&index=0&id=24250886&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24250886",
  null
  
)

export default component.exports